import { EnvironmentOutlined, QuestionCircleOutlined, RadarChartOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import type { ReactNode } from "react";

function formatScore(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) {
    return "—";
  }
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

function ScoreChip({
  icon,
  score,
  tooltip,
  variant,
}: {
  icon: ReactNode;
  score: number | null | undefined;
  tooltip: string;
  variant: "fundamental" | "position";
}) {
  return (
    <span className={`lf-intel-stock-score-item lf-intel-stock-score-item--${variant}`}>
      <span className="lf-intel-stock-score-icon" aria-hidden="true">
        {icon}
      </span>
      <span className="lf-intel-stock-score-value">{formatScore(score)}</span>
      <Tooltip title={tooltip} trigger={["hover", "click"]}>
        <span className="lf-intel-stock-score-help" role="button" tabIndex={0} aria-label={tooltip}>
          <QuestionCircleOutlined />
        </span>
      </Tooltip>
    </span>
  );
}

export function IntelStockAssessScores({
  fundamentalScore,
  positionScore,
}: {
  fundamentalScore?: number | null;
  positionScore?: number | null;
}) {
  return (
    <div className="lf-intel-stock-scores">
      <ScoreChip
        icon={<RadarChartOutlined />}
        score={fundamentalScore}
        tooltip="基本面分：分数越高代表股票基本面越好"
        variant="fundamental"
      />
      <ScoreChip
        icon={<EnvironmentOutlined />}
        score={positionScore}
        tooltip="位置分：分数越高，代表当前位置处于低位"
        variant="position"
      />
    </div>
  );
}
